import {
  GET_NOCONFORMIDADES_REQUEST,
  GET_NOCONFORMIDADES_SUCCESS,
  GET_NOCONFORMIDADES_FAILURE,
  SELECCIONAR_NO_CONFORMIDAD,
  GET_NOCONFORMIDAD_REQUEST,
  CREATE_NOCONFORMIDAD_REQUEST,
  SET_MOSTRAR_BOTON_GUARDAR,
  SET_MOSTRAR_BOTON_TIPOLOGIAS,
  SET_ACTIVE_TAB_FORM,
  GET_NOCONFORMIDAD_SUCCESS,
  UPDATE_NOCONFORMIDAD_REQUEST,
  RESET_NO_CONFORMIDADES,
  NO_CONFORMIDAD_DESELECT,
  SET_MOSTRAR_BOTON_AFECTADOS,
  DELETE_PHOTO_NOCONFORMIDAD_REQUEST,
  SET_MOSTRAR_BARRA_BOTONES_FORM_NC,
} from '../../constants/noconformidades/noconformidades.constants';

export const getNoConformidadesAction = (page, start, limit, busqueda = null, archivado = false) => ({
  type: GET_NOCONFORMIDADES_REQUEST,
  payload: {
    page, start, limit, busqueda, archivado,
  },
});

export const getNoConformidadAction = id => ({
  type: GET_NOCONFORMIDAD_REQUEST,
  payload: {
    id,
  },
});

export const getNoConformidadesSuccessAction = (datos, total, page, start, limit, esListadoFiltrado = false) => ({
  type: GET_NOCONFORMIDADES_SUCCESS,
  payload: {
    datos, total, page, start, limit, esListadoFiltrado,
  },
});

export const getNoConformidadesFailureAction = error => ({
  type: GET_NOCONFORMIDADES_FAILURE,
  payload: error,
});

export const seleccionarNoConformidadAction = seleccionada => ({
  type: SELECCIONAR_NO_CONFORMIDAD,
  payload: { seleccionada },
});

export const crearNoConformidadAction = form => ({
  type: CREATE_NOCONFORMIDAD_REQUEST,
  payload: {
    form,
  },
});

export const setMostrarBotonGuardarAction = mostrarGuardarNc => ({
  type: SET_MOSTRAR_BOTON_GUARDAR,
  payload: { mostrarGuardarNc },
});

export const setMostrarBotonTipologiasAction = mostrarBotonTipologiasNc => ({
  type: SET_MOSTRAR_BOTON_TIPOLOGIAS,
  payload: { mostrarBotonTipologiasNc },
});

export const setMostrarBotonAfectadosAction = mostrarBotonAfectadosNc => ({
  type: SET_MOSTRAR_BOTON_AFECTADOS,
  payload: { mostrarBotonAfectadosNc },
});

export const setMostrarBarraBotonesFormNcAction = mostrarBotonBarraBotonesFormNc => ({
  type: SET_MOSTRAR_BARRA_BOTONES_FORM_NC,
  payload: { mostrarBotonBarraBotonesFormNc },
});

export const setActiveTabFormAction = activeTabFormNc => ({
  type: SET_ACTIVE_TAB_FORM,
  payload: { activeTabFormNc },
});


export const getNoConformidadSuccessAction = resultado => ({
  type: GET_NOCONFORMIDAD_SUCCESS,
  payload: {
    resultado,
  },
});

export const actualizarNoConformidadAction = form => ({
  type: UPDATE_NOCONFORMIDAD_REQUEST,
  payload: {
    form,
  },
});

export const resetNoConformidades = () => ({
  type: RESET_NO_CONFORMIDADES,
});

export const deseleccionarNoConformidadAction = () => ({
  type: NO_CONFORMIDAD_DESELECT,
});

export const eliminarFotoNoConformidadAction = form => ({
  type: DELETE_PHOTO_NOCONFORMIDAD_REQUEST,
  payload: {
    form,
  },
});
